// extracted by mini-css-extract-plugin
export var fadeIn = "_95-0";